import React from 'react'
import PropTypes from 'prop-types'
import compose from 'lodash.compose';
import Page from '../components/page';

import attachI18n from '../components/hoc/attach-i18n'


class ErrorPage extends React.Component {
  static propTypes = {
    code: PropTypes.number,

    i18n: PropTypes.shape({
      exists: PropTypes.func.isRequired
    }).isRequired,
    t: PropTypes.func.isRequired,
    tReady: PropTypes.bool.isRequired
  }

  static defaultProps = {
    code: 500
  }

  static getInitialProps({res, err}) {
    console.error(err);
    const code = res ? res.statusCode : (err ? err.statusCode : null)

    return {code}
  }

  render() {
    const {code, i18n, t, tReady} = this.props

    const message = i18n.exists(`errors.http.${code}`) ? t(`errors.http.${code}`) : t('errors.unknown')

    return (
      <Page ready={tReady}>
        {() => (
          <>
            {/*<Meta title={t('errors.title', {code})} description={message} />*/}
            <div>
              <section id="banner">
                <div className="inner">
                  <header className="major">
                    <h1>{t('errors.title', {code})}</h1>
                  </header>
                  <p>
                    {message}
                  </p>
                </div>
              </section>
            </div>
          </>
        )}
      </Page>
    )
  }
}

export default compose(
  attachI18n(),
)(ErrorPage)
